var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForsteLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.41 63.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eed23c;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.16,0h31.26v11.86h-19.35v11.6h10.86v11.69h-10.86v28.77h-11.9V0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 18.53,
    height: 11.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.77 11.96 32.67 11.96 32.67 0 20.77 0 20.77 11.86 20.77 11.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.68,
    y: 23.47,
    width: 10.85,
    height: 11.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.77 23.47 20.77 35.16 20.77 37.71 20.77 63.92 32.67 63.92 32.67 13.71 20.77 13.71 20.77 23.47"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForsteLogo);
export default __webpack_public_path__ + "static/media/ForsteLogo.81c0a5fc82c42a4a3aee57a56215aa23.svg";
export { ForwardRef as ReactComponent };